import { render } from "./InfoFooter.vue?vue&type=template&id=464f4a16&scoped=true"
const script = {}

import "./InfoFooter.vue?vue&type=style&index=0&id=464f4a16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464f4a16"]])

export default __exports__